export default __webpack_public_path__ + "952bef5680a7a67d5d2be7122f2bd227.svg";